export default __webpack_public_path__ + "static/media/area-14.08e1c5a0.jpg";